import type { DummyFoods } from './dummyFoods'

export const lettuce: DummyFoods = {
  Lettuce: {
    Boston: ['Boston lettuce'],
    Butter: ['Butter lettuce'],
    'Green leaf': ['Green leaf lettuce'],
    Iceberg: ['Iceberg lettuce'],
    'Red leaf': ['Red leaf lettuce'],
    Romaine: ['Romaine lettuce'],
  },
}
